<template>
  <div class="header">
    <div class="header_img"></div>
    <div class="left_font">
      <div class="font_img"></div>
      <div class="font_jiu">木棉树高炉3D可视化平台</div>
    </div>
    <ul class="button">
      <li :class="clickn?'clickn':'notclickn'" @click="change_1()">
        <div :class="$store.state.isactive_1?'but_li active':'but_li'" style="width:7rem;">
          <div class="button_xian"></div>
          <div class="button_font">
            <span>主页面</span>
            <span>Main Page</span>
          </div>
          <div class="button_xian"></div>
        </div>
      </li>
      <li :class="clickn?'clickn':'notclickn'" @click="change_2()">
        <div :class="$store.state.isactive_2?'but_li active':'but_li'" style="width:4.5rem;">
          <div class="button_font">
            <span>高炉本体</span>
            <span>Blast furnace body</span>
          </div>
        </div>
      </li>
      <li :class="clickn?'clickn':'notclickn'" @click="change_3()">
        <div :class="$store.state.isactive_3?'but_li active':'but_li'" style="width:9.375rem;">
          <div class="button_xian"></div>
          <div class="button_font">
            <span>炉顶系统</span>
            <span>Furnace roof system</span>
          </div>
          <div class="button_xian"></div>
        </div>
      </li>
      <li :class="clickn?'clickn':'notclickn'" @click="change_4()">
        <div :class="$store.state.isactive_4?'but_li active':'but_li'" style="width:6.25rem;">
          <div class="button_font">
            <span>热风炉系统</span>
            <span>Hot stove system</span>
          </div>
        </div>
      </li>
      <li :class="clickn?'clickn':'notclickn'" @click="change_5()">
        <div :class="$store.state.isactive_5?'but_li active':'but_li'" style="width:10.9375rem;">
          <div class="button_xian"></div>
          <div class="button_font">
            <span>槽下上料系统</span>
            <span>Feeding under the trough</span>
          </div>
          <div class="button_xian"></div>
        </div>
      </li>
    </ul>
    <div class="headbtn">
      <div class="headbtn-item notnav" @click="xunyou">
        <img src="~@/assets/img/xunjian.png"/>
        <div>{{xunjiantitle}}</div>
      </div>
      <div :class="clickn?'headbtn-item nav clickn':'headbtn-item nav notclickn'" @click="fhzuye">
        <img src="~@/assets/img/chushihua.png"/>
        <div>返回主界面</div>
      </div>
    </div>
    <div
      class="time"
    >{{my_year}}-{{my_mouth | timefilter}}-{{my_data | timefilter}} {{my_week | weekfilter}} {{my_hour | timefilter}}:{{my_minutes | timefilter}}</div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");
export default {
  data() {
    return {
      my_year: "",
      my_mouth: "",
      my_data: "",
      my_hour: "",
      my_minutes: "",
      my_seconds: "",
      my_week: "",
      clickn: true,
      xunjianclick:true,
      xunjiantitle:'自动巡游'
    };
  },
  filters: {
    timefilter(date) {
      if (date < 10) return "0" + date;
      else return date;
    },
    weekfilter(e) {
      var week = ["一", "二", "三", "四", "五", "六", "日"];
      return "星期" + week[e];
    }
  },
  mounted() {
    this.getdate();
    setInterval(this.getdate, 100);
    window.btnclick = this.btnclick;
  },
  methods: {
    xunyou(){
      if(this.xunjianclick){
        document.getElementById("iframe").contentWindow.xunyou();
        this.xunjiantitle = '停止巡游'
      }else{
        document.getElementById("iframe").contentWindow.stopxunyou();
        this.xunjiantitle = '自动巡游'
      }
      this.xunjianclick = !this.xunjianclick
      
    },
    fhzuye(){
      document.getElementById("iframe").contentWindow.fhzhuye();
    },
    btnclick(val) {
      // console.log(val, "dsada");
      this.clickn = val;
    },
    change_1() {
      this.$store.commit("changestate_1");
      this.$router.push("/home");
      document.getElementById("iframe").contentWindow.MMAPI.mainpage();
    },
    change_2() {
      this.$store.commit("changestate_2");
      this.$router.push("/furnacebody");
      document.getElementById("iframe").contentWindow.MMAPI.maingaolu();
    },
    change_3() {
      this.$store.commit("changestate_3");
      this.$router.push("/roofsystem");
      document.getElementById("iframe").contentWindow.MMAPI.roofsystem();
    },
    change_4() {
      this.$store.commit("changestate_4");
      this.$router.push("/hotblastsystem");
      document.getElementById("iframe").contentWindow.MMAPI.hotblastsystem();
    },
    change_5() {
      this.$store.commit("changestate_5");
      this.$router.push("/undergroovesystem");
      document.getElementById("iframe").contentWindow.MMAPI.undergroovesystem();
    },
    getdate() {
      //console.log(moment().year())
      this.my_year = moment().year();
      this.my_mouth = moment().month() + 1;
      this.my_data = moment().date();
      this.my_hour = moment().hours();
      this.my_minutes = moment().minutes();
      this.my_seconds = moment().seconds();
      this.my_week = moment().weekday();
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: url("@/assets/background.png") no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 5.3125rem;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  // background: #1c2a2b;
  // opacity: 0.8;
  .headbtn{
    display: flex;
    height: 3.5125rem;
    align-items: center;
    .headbtn-item{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 121px;
      height: 29.07px;
      font-size: 14px;
      margin-left: 12px;
      cursor: pointer;
      img{
        margin-right: 2px;
      }
    }
    .notnav{
      color: #fff;
      background: url("~@/assets/img/btnbg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .nav{
      color: #00caff;
      background: url("~@/assets/img/btnbgnav.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .header_img {
    background: url("@/assets/img/header.png") no-repeat center center;
    background-size: 99% 100%;
    width: 100%;
    height: 2rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .left_font {
    width: 43.75rem;
    height: 100%;
    display: flex;
    .font_img {
      width: 14.9375rem;
      height: 3.375rem;
      background: url("@/assets/img/moneng.png") no-repeat center center;
      background-size: 100% 100%;
      // margin-left: 0.78vw;
      margin-top:0.5vh;
      margin-left:1vw;
      
    }
    .font_jiu {
      font-size: 33px;
      color: white;
      transform: translateY(-0.625rem);
      margin-left: 0.625rem;
      margin-top: 1.375rem;
      font-weight: bold;
      letter-spacing:5px;
    }
  }
  .button {
    width: 41.0625rem;
    height: 3.125rem;
    display: flex;
    justify-content: space-between;
    line-height: 3.125rem;
    margin-left: 1.875rem;
    user-select: none;
    .but_li {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 8.125rem;
      // margin-left: 10px;
      .button_xian {
        width: 0.9375rem;
        height: 0.1875rem;
        // line-height: .125rem;
        background: #039ac5;
        margin-top: 0.1875rem;
        // margin-right: 17px;
      }
      .button_font {
        // box-sizing: border-box;
        width: 100%;
        // padding-left: 20px;
        height: 100%;
        font-size: 0.75rem;
        display: flex;
        flex-direction: column;
        text-align: center;
        // margin: 0 1.0625rem 0 1.0625rem;
        // overflow: hidden;
        span:nth-child(1) {
          height: 1.25rem;
          line-height: 2.5rem;
          font-size: 14px;
          margin-top: 0.1875rem;
        }
        span:nth-child(2) {
          height: 1.25rem;
          line-height: 2.1875rem;
          font-size: 8px;
          transform: scale(0.74);
        }
      }
      .button_font:hover {
        transform: scale(1.05);
      }
    }
  }
  .notclickn {
    pointer-events: none;
  }
  .clickn {
    pointer-events: auto;
  }
  .time {
    font-size: 0.9375rem;
    position: absolute;
    right: 1.25rem;
    top: 1.4375rem;
  }
}
.active {
  color: #039ac5;
}
</style>